export default __webpack_public_path__ + "static/media/benefit_18.54cbc84e.png";